import { useTournamentCtx } from '@features/tournament/providers/TournamentProvider';
import { TournamentParticipantsWidget } from '@features/tournament/ui/components/TournamentParticipants';
import { TournamentResultsWidget } from '@features/tournament/ui/components/TournamentResultsWidget/TournamentResultsWidget';

import styles from './TournamentParticipantsMegaWidget.module.css';

/**
 * Над-виджет.
 * Определяет, надо ли показывать результаты турнира или просто табличку участников.
 */
export function TournamentParticipantsMegaWidget({
  resultsTab,
  onResultsTabChange,
}: {
  resultsTab: 'table' | 'rounds' | 'list' | 'teams';
  onResultsTabChange: (resultsTab: 'table' | 'rounds' | 'list' | 'teams') => void;
}) {
  const { state } = useTournamentCtx();

  if (state.isLoading) return null;

  // Как только появляются раунды (активные или законченные)
  const showResults = Boolean(state.lastRound);

  return showResults ? (
    <TournamentResultsWidget resultsTab={resultsTab} onResultsTabChange={onResultsTabChange} />
  ) : (
    <TournamentParticipantsWidget className={styles.participants} />
  );
}
